export default "__VITE_ASSET__PGUCm1bw__"